export const NOTIFI_TYPE = {
  unreadNotifi: 1,
  readNotifi: 2,
};
